var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { Button } from '../../Button';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  width: 100%;\n  padding: 16px;\n"], ["\n  box-sizing: border-box;\n  width: 100%;\n  padding: 16px;\n"])));
var Row = styled(Container)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
var Column = styled(Container)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var fillParent = { flex: 1 };
var rightSpacer = { marginRight: '10px' };
var bottomSpacer = { marginBottom: '10px' };
export var DrawerFooter = function (_a) {
    var view = _a.view, primaryButton = _a.primaryButton, secondaryButton = _a.secondaryButton;
    switch (view) {
        case 'one':
            return (React.createElement(Container, null,
                React.createElement(Button, __assign({}, primaryButton, { style: { width: '100%' } }))));
        case 'two':
            return (React.createElement(Row, null,
                React.createElement(Button, __assign({}, primaryButton, { style: __assign(__assign({}, fillParent), rightSpacer) })),
                React.createElement(Button, __assign({}, __assign({ variant: 'outline' }, secondaryButton), { style: fillParent }))));
        case 'one-above-one':
            return (React.createElement(Column, null,
                React.createElement(Button, __assign({}, primaryButton, { style: __assign(__assign({}, fillParent), bottomSpacer) })),
                React.createElement(Button, __assign({}, __assign({ variant: 'flat' }, secondaryButton), { style: fillParent }))));
        default:
            return React.createElement(React.Fragment, null);
    }
};
var templateObject_1, templateObject_2, templateObject_3;
